module.exports = __webpack_public_path__ + "33506dff758dfb1aa222bd5b90c73761.svg";